import { render, staticRenderFns } from "./InsertDeadPata.vue?vue&type=template&id=e61f316c"
import script from "./InsertDeadPata.vue?vue&type=script&lang=js"
export * from "./InsertDeadPata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports